import { render, staticRenderFns } from "./AllLogsUpgradeTable.vue?vue&type=template&id=372f70b8&scoped=true&"
import script from "./AllLogsUpgradeTable.vue?vue&type=script&lang=js&"
export * from "./AllLogsUpgradeTable.vue?vue&type=script&lang=js&"
import style0 from "./AllLogsUpgradeTable.vue?vue&type=style&index=0&id=372f70b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f70b8",
  null
  
)

export default component.exports